"use strict";
// (C) 2021 GoodData Corporation
// "Original" here: https://github.com/moroshko/shallow-equal/blob/master/src/objects.js
Object.defineProperty(exports, "__esModule", { value: true });
exports.shallowEqualObjects = void 0;
/**
 * @internal
 */
function shallowEqualObjects(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}
exports.shallowEqualObjects = shallowEqualObjects;
//# sourceMappingURL=objectUtils.js.map